<template lang="html">
  <div class="text-in-center container">
    <div class="text-in-center-content">
      <h2 class="text-center-header">
        <slot name="text-center-header"> </slot>
      </h2>
      <div class="text-center-body mt-3">
          <slot name="text-center-body"> </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  .text-in-center {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns:  repeat(12, 1fr);
  }
  .text-in-center-content {
    grid-column: 1/13;
    padding: 1em;
  }

  @media (min-width: 768px) {
    .text-in-center-content {
      grid-column: 2/12;
      text-align: center;
    }
  }

  @media (min-width: 992px) {
    .text-in-center-content {
      grid-column: 3/11;
    }
  }

  @media (min-width: 1440px) {
    .text-in-center {
      margin-top: 5em;
    }
  }
</style>
